module.exports = __webpack_public_path__ + "img/backgr-home-first-section.309952a9.png";